/**
 * Backend Socket.IO order events (Shopify webhook → server → clients).
 * Match the live backend contract exactly.
 */
export const ORDER_SOCKET_EVENTS = {
  CREATED: "order:created",
  UPDATED: "order:updated",
};

/** Pull order identity fields from whatever payload shape the backend emits. */
export function extractOrderIdsFromSocketPayload(payload) {
  if (!payload || typeof payload !== "object") return [];

  const candidates = [
    payload,
    payload.data,
    payload.order,
    payload.data?.order,
  ].filter(Boolean);

  const ids = [];
  for (const item of candidates) {
    [
      item.ItemID,
      item.itemId,
      item.ShopifyItemID,
      item.shopifyItemId,
      item.ShopifyId,
      item.shopifyId,
      item.BackerID,
      item.backerId,
      item.orderId,
      item.id,
    ].forEach((value) => {
      if (value !== undefined && value !== null && value !== "") {
        ids.push(String(value));
      }
    });
  }

  return [...new Set(ids)];
}
